import type { LayerProps } from "react-map-gl"
import type { HeatmapPaint } from "../../types"

export const heatmapLayer: LayerProps & {
  type: "heatmap"
  paint: HeatmapPaint
} = {
  id: "places-heat",
  type: "heatmap",
  source: "places-heat",
  paint: {
    "heatmap-radius": ["interpolate", ["linear"], ["zoom"], 8, 1, 10, 16, 12, 32, 13, 40, 14, 60, 20, 200],
    "heatmap-opacity": ["interpolate", ["linear"], ["zoom"], 8, 0.4, 11, 0.2, 20, 0.3],
    "heatmap-intensity": 0.6,
    "heatmap-weight": ["interpolate", ["linear"], ["get", "score_combined"], 0, 0, 0.2, 0.6, 1, 1],
    "heatmap-color": [
      "interpolate",
      ["linear"],
      ["heatmap-density"],
      0.1,
      "hsla(240, 80%, 94%, 0.2)",
      0.2,
      "hsla(125, 63%, 88%, 0.4)",
      0.4,
      "hsla(192, 84%, 80%, 0.4)",
      0.6,
      "hsla(274, 100%, 65%, 0.5)",
      0.95,
      "hsla(300, 100%, 50%, 0.6)",
      1.1,
      "hsla(42, 100%, 64%, 0.6)",
    ],
  },
}

export const createHeatmapSource = (heatmapData: any) => ({
  id: "places-heat",
  type: "geojson" as const,
  data: heatmapData,
})
